export default {
  name: 'TyreDesignModel',

  data () {
    return {
      model: {
        Id    : null,
        Name  : '',
        Active: true
      },

      validationRules: {
        Id    : { required: false, type: 'integer' },
        Name  : { required: true, maxLen: 50, type: 'string' },
        Active: {
          required: true,
          type    : 'boolean'
        }
      },

      validationErrorMessages: {
        el: {},
        en: {}
      }

    }
  }

}
